import {useCallback, useEffect, useState} from "react";
import axios from "axios";
import {PATHS_API} from "../../../enum";

interface IAlert {
    _id: string,
    level: "critical" | "error",
    source: string,
    title: string,
    details: string,
    count: number,
    firstAt: string,
    lastAt: string,
}

const SOURCES: Record<string, string> = {
    donatik: "Донатік",
    refund: "Повернення",
    giveaway: "Розіграші",
    lootbox: "Ящик",
    config: "Налаштування",
    transfer: "Переказ",
    bonuscode: "Бонус-код",
    purchase: "Покупки",
    betatransfer: "Betatransfer",
    sense: "Sense Bank",
};

const time = (iso: string) => new Date(iso).toLocaleString("uk-UA");

// Критичні події сервера: те, що раніше було лише в логах. Однакові події згруповані з лічильником
const SystemAlerts = ({ onError }: { onError: (message: string) => void }) => {
    const [list, setList] = useState<IAlert[]>([]);

    const load = useCallback(() => {
        axios.get(PATHS_API.ADMIN_ALERTS, { withCredentials: true })
            .then(({ data }) => setList(data))
            .catch(() => {});
    }, []);

    useEffect(() => {
        load();
        const timer = window.setInterval(load, 60_000);
        return () => window.clearInterval(timer);
    }, [load]);

    const resolve = async (a: IAlert) => {
        if (!window.confirm(`Позначити «${a.title}» розібраним? Якщо подія повториться, вона з'явиться знову.`)) return;
        try {
            await axios.post(`${PATHS_API.ADMIN_ALERTS}/${a._id}/resolve`, {}, { withCredentials: true });
            setList((l) => l.filter((x) => x._id !== a._id));
        } catch (err: any) {
            onError(err.response?.data?.message || "Не вдалося позначити подію");
        }
    };

    if (!list.length) return null;

    const critical = list.filter((a) => a.level === "critical").length;

    return (
        <div className={`adm-alerts ${critical ? "has-critical" : ""}`}>
            <div className="adm-problems-head">
                <span className="adm-problems-icon" aria-hidden="true">!</span>
                <div>
                    <b>Системні попередження: {list.length}{critical ? ` (критичних: ${critical})` : ""}</b>
                    <span>Події сервера, які потребують уваги. Після виправлення позначте «Розібрано».</span>
                </div>
            </div>

            { list.map((a) =>
                <div key={a._id} className={`adm-problem adm-alert-${a.level}`}>
                    <div className="adm-problem-top">
                        <span className="adm-alert-level">{a.level === "critical" ? "Критично" : "Помилка"}</span>
                        <span className="adm-problem-reason">{a.title}</span>
                        <span className="adm-tag adm-tag-type">{SOURCES[a.source] ?? a.source}</span>
                    </div>
                    <p className="adm-problem-details">{a.details}</p>
                    <div className="adm-alert-foot">
                        <span className="adm-muted">
                            { a.count > 1
                                ? `${a.count} рази · вперше ${time(a.firstAt)} · востаннє ${time(a.lastAt)}`
                                : time(a.lastAt) }
                        </span>
                        <button type="button" className="adm-primary-btn" onClick={() => resolve(a)}>Розібрано</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SystemAlerts;
